import { ReportPeriodWithLabel } from "@common/types/reports/types";
import { ColumnPin } from "@common/types/views/views";

/**
 * Width the name column keeps when a report covers a single period, so the
 * amounts stay beside the account names instead of drifting to the far edge of
 * a wide screen. With one 200px amount column this reproduces the 720px report
 * width from PRO-7373; Trial Balance shows a debit and a credit column, so its
 * block is that much wider. ViewTable centers the columns in the full-width
 * table (`centerColumns`).
 */
export const SINGLE_COLUMN_LABEL_MAX_SIZE = 520;

export function hasSingleValueColumn(
    periods: ReportPeriodWithLabel[],
): boolean {
    return periods.length <= 1;
}

export function getLabelColumnMaxSize({
    periods,
    labelMaxSize,
}: {
    periods: ReportPeriodWithLabel[];
    labelMaxSize: number;
}): number {
    return hasSingleValueColumn(periods)
        ? SINGLE_COLUMN_LABEL_MAX_SIZE
        : labelMaxSize;
}

/**
 * Pinning only earns its keep while the table scrolls sideways. A single-column
 * report never does, and pinned columns would stick to the table edges instead
 * of centering with the rest.
 */
export function getColumnPinOptions({
    periods,
    pin,
}: {
    periods: ReportPeriodWithLabel[];
    pin: ColumnPin;
}): { pin: ColumnPin } | undefined {
    return hasSingleValueColumn(periods) ? undefined : { pin };
}
